import React from 'react';

/**
 * Insurance column cell: insurance name on line 1, and the patient's insurance ID
 * on line 2. For Medicare we show the patient's MBI. For non-Medicare plans we do
 * not yet surface the member ID.
 * TODO(non-medicare): show the member / insurance ID for non-Medicare plans once
 * it is available on the billing-cycle response.
 */
export const InsuranceCell: React.FC<{
  insuranceName: string;
  mbi?: string | null;
  isMedicare?: boolean | null;
}> = ({ insuranceName, mbi, isMedicare }) => (
  <div className='flex flex-col'>
    <span>{insuranceName}</span>
    {isMedicare && mbi ? (
      <span className='text-xs text-muted-foreground'>{mbi}</span>
    ) : null}
  </div>
);
